module.exports = __webpack_public_path__ + "static/img/fourth.b7f9780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fourth.png
// module id = fr2j
// module chunks = 1